import { createContext, useContext } from "react";

export const GeoMapContext = createContext({ cesiumVisible: false });

export const useCesiumVisible = () => !!useContext(GeoMapContext)?.cesiumVisible;